import { render, staticRenderFns } from "./BestellingendagIndex.vue?vue&type=template&id=66759d50&scoped=true&"
import script from "./BestellingendagIndex.vue?vue&type=script&lang=js&"
export * from "./BestellingendagIndex.vue?vue&type=script&lang=js&"
import style0 from "./BestellingendagIndex.vue?vue&type=style&index=0&id=66759d50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66759d50",
  null
  
)

export default component.exports